<template>
  <div id="app">

    <router-view/>

  </div>
</template>
<script>
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/storage');

import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
import Holdingtable from './components/Holdingtable'
export default {
  name: 'app',
  components: {
    Sidebar,
    Navbar,
    Holdingtable
  }
}

</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #25455b;
}

.btn-primary {
  background-color: #25455b !important;
  border-color: #25455b !important;
}


</style>
